import { getErrorMessage } from '../../utils/errorMessage';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { getDeviceId } from '../../utils/deviceId';

const client = axios.create({ baseURL: API_BASE_URL, timeout: 10000 });

client.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Xiaoying-Device-ID'] = getDeviceId();
  return config;
});

function unwrap(response) {
  const payload = response?.data;
  if (Number(payload?.code) === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  if (!payload || Number(payload.code) !== 200) {
    const error = new Error(payload?.message || '消息服务暂不可用');
    error.code = payload?.data?.error_code || payload?.code;
    throw error;
  }
  return payload.data;
}

export async function getSystemMessages(category, options = {}) {
  return unwrap(await client.get('/message/list', {
    params: {
      category,
      unread_only: options.unreadOnly ? 1 : 0,
      page: options.page || 1,
      per_page: options.perPage || 100,
    },
  }));
}

export async function readSystemMessage(id) {
  return unwrap(await client.post('/message/read', { id }));
}

export async function readAllSystemMessages(category) {
  return unwrap(await client.post('/message/read-all', { category }));
}

export async function claimSystemMessage(id) {
  return unwrap(await client.post('/message/claim', { id }));
}

export function systemMessageApiError(error, fallback = '消息服务暂不可用，请稍后重试') {
  return getErrorMessage(error, fallback);
}
